import type {
  TextareaProps as ChakraTextareaProps,
  ThemingProps,
} from '@chakra-ui/react';
import { Textarea as ChakraTextarea } from '@chakra-ui/react';
import type React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';

export interface TextareaProps
  extends OmitChakraProps<
    ChakraTextareaProps,
    'children' | 'disabled' | 'required' | 'isRequired' | keyof ThemingProps
  > {
  size?: 'md' | 'lg';
  variant?: 'hidden' | 'outline';
}

export const Textarea: (props: TextareaProps) => React.JSX.Element =
  ChakraTextarea;
